// Lazy load transliteration for better tree-shaking and bundle optimization
let transliterationModule: any = null;

async function getTransliteration() {
  if (!transliterationModule) {
    transliterationModule = await import('transliteration');
  }
  return transliterationModule;
}

// Simple ASCII slugification for basic cases (no transliteration needed)
function simpleSlugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special chars
    .replace(/[\s_-]+/g, '-') // Replace spaces/underscores with hyphens
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
}

// Check if text needs transliteration (contains non-ASCII chars)
function needsTransliteration(text: string): boolean {
  return /[^\x00-\x7F]/.test(text);
}

export async function asyncSlugify(text: string): Promise<string> {
  // For basic ASCII text, use simple method to avoid loading transliteration
  if (!needsTransliteration(text)) {
    return simpleSlugify(text);
  }

  // Only load transliteration for non-ASCII text
  const { slugify: originalSlugify } = await getTransliteration();
  return originalSlugify(text, {});
}

// Synchronous version for cases where async is not possible (fallback)
export function slugifySync(text: string): string {
  if (!needsTransliteration(text)) {
    return simpleSlugify(text);
  }
  
  // Fallback: just use simple method even for non-ASCII
  // This is not ideal but avoids bundle size issues
  return simpleSlugify(text.replace(/[^\x00-\x7F]/g, ''));
}

// Default export for backward compatibility (synchronous)
export default function defaultSlugify(text: string): string {
  return slugifySync(text);
}